import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {WinPresentationModule} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationModule';
import {WinPresentationView} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationView';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {SpinButtonEvents} from '@gongxigames/framework/slot/modules/spinbutton';
import {BigWinEvents} from '@gongxigames/framework/slot/modules/bigwin';

export class WinPresentationBasicState extends ModuleState<WinPresentationView, WinPresentationModule> {

    private stopped = false;

    public onEnterState(): void {
        this.stopped = false;
    }

    public onLeaveState(): void {}

    protected setupEvents(): void {
        this.setEventHandler(FlowModuleEvents.WON, this.onWon.bind(this));
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted.bind(this));
        this.setEventHandler(SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onReelsSpinningStarted.bind(this));
        this.setEventHandler(BigWinEvents.FINISHED, this.onBigWinFinished.bind(this));
    }

    protected onBigWinFinished(): void {
        if (this.module.isIndividualWinMustBePaused) {
            this.module.isIndividualWinMustBePaused = false;
        }
    }

    protected onReelsSpinningStarted(): void {
        if (!this.stopped) {
            this.module.stop();
            this.module.stopMeter(false);
            this.stopped = true;
        }
    }

    protected onWon(): void {
        this.module.gotoState(WinPresentationModule.INITIAL_STATE);
    }
}
